import { render, staticRenderFns } from "./BrandFilter.vue?vue&type=template&id=76b1a498"
import script from "./BrandFilter.vue?vue&type=script&lang=js"
export * from "./BrandFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports